<template>
  <div id="invitation">
    <top></top>
    <div class="main">
      <!-- 左侧菜单 -->
      <navMenu :active="active"></navMenu>
      <!-- 右侧内容区域 -->
      <div class="content">
        <div class="main-title">
          {{ lang === "cn" ? "客户邀请" : "Visitor Invitation" }}
        </div>
        <div class="content-main">
          <div class="cds-poster">
            <div class="cds-mask">
              <!-- <div class="cds-button">
                {{ lang === "cn" ? "下载邀请函" : "Download" }}
              </div> -->
              <div class="cds-button" @click="toCustomizeInvitation">
                {{ lang === "cn" ? "自定义邀请函" : "Customize" }}
              </div>
              <!-- <div class="cds-button">
                {{ lang === "cn" ? "下载注册二维码" : "QRcode" }}
              </div> -->
            </div>
          </div>
          <div class="cds-audience">
            <div class="cds-audience-title">
              <p>
                {{ lang === "cn" ? "已邀请观众列表" : "Invited visitors list"
                }}<span>
                  {{
                    lang === "cn"
                      ? `(总邀请人数: ${total})`
                      : `(total invited: ${total})`
                  }}</span
                >
              </p>
              <!-- <div @click="handleShowRankings">
                {{ lang === "cn" ? "排行榜" : "rankings" }} 》
              </div> -->
            </div>
            <el-table
              :data="tableData"
              stripe
              style="width: 100%"
              :empty-text="lang === 'cn' ? '暂无数据' : 'No Records Found'"
            >
              <el-table-column
                prop="customerName"
                :label="lang === 'cn' ? '姓名' : 'Name'"
                min-width="150"
              >
              </el-table-column>
              <el-table-column
                prop="companyName"
                :label="lang === 'cn' ? '公司' : 'Company'"
                min-width="240"
              >
              </el-table-column>
              <el-table-column
                prop="deptName"
                :label="lang === 'cn' ? '部门' : 'Department'"
                min-width="150"
              >
              </el-table-column>
              <el-table-column
                prop="job"
                :label="lang === 'cn' ? '职位' : 'Position'"
                min-width="150"
              >
              </el-table-column>
              <el-table-column
                prop="createTime"
                :label="lang === 'cn' ? '登记时间' : 'Registration Time'"
                min-width="300"
              >
              </el-table-column>
            </el-table>
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="pageSize"
              :current-page="currentPage"
              @current-change="handleCurrentPageChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <div class="conf-btn flex">
        <div class="btn" @click="handleCompleteSteps">
          {{ lang === "cn" ? "完成" : "Complete" }}
        </div>
      </div>
    </div>
    <el-dialog
      :title="lang === 'cn' ? '排行榜' : 'Rankings'"
      :visible.sync="showRankings"
      width="30%"
    >
      <el-table :data="rankingsTableData" style="width: 100%">
        <el-table-column
          :label="lang === 'cn' ? '排行' : 'ranking'"
          min-width="80"
          align="center"
        >
          <template slot-scope="scope">
            <div :class="{ ranking: scope.row.ranking <= 3 }">
              {{ scope.row.ranking }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="company_name"
          :label="lang === 'cn' ? '公司名称' : 'Company'"
          min-width="280"
        >
        </el-table-column>
        <el-table-column
          prop="quantity"
          :label="lang === 'cn' ? '数量' : 'quantity'"
          align="center"
          min-width="80"
        >
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
import {
  skipOrNextStep,
  getAudienceList,
  getAlreadyMadeCdsInvitation,
} from "../api/api";
export default {
  components: { top, navMenu },
  name: "cdsInvitation",
  data() {
    return {
      stepMenuList: [],
      active: "",
      detail: "",
      lang: "",
      showRankings: false,
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      rankingsTableData: [
        {
          ranking: 1,
          company_name: "威海百合生物技术股份有限公司",
          quantity: 84,
        },
        {
          ranking: 2,
          company_name: "广州一品红制药有限公司",
          quantity: 76,
        },
        {
          ranking: 3,
          company_name: "安徽美誉制药有限公司",
          quantity: 70,
        },
        {
          ranking: 4,
          company_name: "广州市桐晖药业有限公司",
          quantity: 54,
        },
      ],
    };
  },
  created() {
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "/cdsInvitaion";
    });
    this.detail = stepMenuList[index];
    this.active = index;
    this.lang = localStorage.getItem("language");
    this.getInvitation();
    this.getAudienceData();
  },
  methods: {
    async getInvitation() {
      const res = await getAlreadyMadeCdsInvitation();
      if (res.data.code == 1) {
      } else {
        if (this.lang === "cn") {
          this.$message.error(res.data.msg);
        } else {
          this.$message.error("Failed to retrieve Invitation!");
        }
      }
    },
    async getAudienceData() {
      let languageType;
      if (this.lang === "cn") {
        languageType = 1;
      } else {
        languageType = 2;
      }
      let data = {
        languageType,
        nowPage: this.currentPage,
        pageShow: this.pageSize,
      };
      const res = await getAudienceList(this.$qs.stringify(data));
      console.log(res);
      if (res.data.code == 1) {
        this.tableData = res.data.data.results;
        this.total = res.data.data.totalNum;
      } else {
        if (this.lang === "cn") {
          this.$message.error(res.data.msg);
        } else {
          this.$message.error("Failed to retrieve Audience List!");
        }
      }
    },
    handleCurrentPageChange(val) {
      this.currentPage = val;
      this.getAudienceData();
    },
    toCustomizeInvitation() {
      this.$router.push({
        path: "/cdsCustomizeInvitation",
      });
    },
    handleShowRankings() {
      this.showRankings = true;
    },
    async handleCompleteSteps() {
      let data = {
        action: 2,
        mark: this.detail.mark,
      };
      const res = await skipOrNextStep(data);
      if (res.data.code == 1) {
        if (this.lang === "cn") {
          this.$message.success(res.data.msg);
          location.reload();
        } else {
          this.$message.success("Operation successful");
        }
      } else {
        if (this.lang === "cn") {
          this.$message.error(res.data.msg);
        } else {
          this.$message.error("Operation failed");
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.content-main {
  background-color: #fff;
  margin-top: 20px;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 30px 20px 300px;
  display: flex;
  .cds-poster {
    width: 350px;
    height: 700px;
    background-image: url("https://oss.chinadentalshow.com/uploads/images/20250811/20250811112911257fe1937.jpg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    margin-right: 60px;
    position: relative;
    .cds-mask {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      .cds-button {
        width: 136px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border: 1px solid #1677ff;
        background: rgba(22, 119, 255, 0.9);
        color: #fff;
        border-radius: 6px;
        font-weight: 700;
        cursor: pointer;
      }
      .cds-button:hover {
        background: rgba(22, 119, 255, 1);
      }
    }
  }
  .cds-audience {
    width: calc(100% - 410px);
    .cds-audience-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      p {
        color: #2c2c2e;
        font-size: 20px;
        font-weight: 500;
        span {
          color: #636366;
          font-size: 16px;
        }
      }
      div {
        background-color: #fc933f;
        padding: 0 4px 0 10px;
        line-height: 28px;
        font-size: 14px;
        color: #fff;
        font-weight: 500;
        border-radius: 6px;
        cursor: pointer;
      }
    }
    .el-pagination {
      margin-top: 80px;
      text-align: right;
      margin-right: 40px;
    }
  }
}
.conf-btn {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  .btn {
    min-width: 148px;
    height: 40px;
    cursor: pointer;
    font-size: 19px;
    margin: 0 10px;
    font-weight: 500;
    color: #2690e6;
    line-height: 40px;
    text-align: center;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #008dff;
    &:hover {
      text-decoration: underline;
    }
  }
  .next-btn {
    color: #fff;
    background: #008dff;
  }
}
/deep/ .el-dialog {
  border-radius: 10px;
  .el-dialog__body {
    padding-top: 10px;
  }
  .ranking {
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    background-color: #eab572;
    font-size: 14px;
    color: #fff;
    margin: 0 auto;
    border-radius: 50%;
  }
}
</style>